export var saveAsFile = function (obj, name) {
    var jsonString = JSON.stringify(obj);
    var blob = new Blob([jsonString], { type: 'application/json' });
    var link = document.createElement('a');
    link.download = "".concat(name, ".json");
    link.href = URL.createObjectURL(blob);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
